import Axios from "axios";
import {
  GetCollaborationStoresFilter,
  GetCollaborationStoresRequest,
  GetCollaborationStoresResponse,
  IsVisitCollaborationStoreRequest,
} from "../models/collaborationStores.model";
import { ApiResultModel } from "../models/common.model";
import { ApiBaseUrl, StoreUrl } from "../config/config";

export const GetCollaborationStores = async (
  data: GetCollaborationStoresRequest,
): Promise<ApiResultModel<GetCollaborationStoresResponse[]>> => {
  return await Axios.post<ApiResultModel<GetCollaborationStoresResponse[]>>(
    ApiBaseUrl + StoreUrl + "/GetCollaborationStores",
    data,
  ).then((result) => {
    return result.data;
  });
};

export const GetCollaborationStoreExcel = async (
  data: GetCollaborationStoresFilter,
) => {
  return await Axios({
    method: "POST",
    url: ApiBaseUrl + StoreUrl + "/GetCollaborationStoresExcel",
    data,
    responseType: "blob",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/pdf",
    },
  }).then((response: any) => {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `${"لیست درخواست پذیرندگان"}.xlsx`);
    document.body.appendChild(link);
    link.click();
  });
};

export const GetCollaborationStoreZipFile = async (data: {
  key: string;
  companyName: string;
}) => {
  return await Axios({
    method: "POST",
    url: ApiBaseUrl + StoreUrl + "/GetCollaborationStoreZipFile",
    data,
    responseType: "blob",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/pdf",
    },
  }).then((response: any) => {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute(
      "download",
      `${data.companyName}_مستندات درخواست همکاری.zip`,
    );
    document.body.appendChild(link);
    link.click();
  });
};

export const IsVisitCollaborationStore = (
  request: IsVisitCollaborationStoreRequest,
): Promise<GetCollaborationStoresResponse> => {
  return Axios.post<ApiResultModel<GetCollaborationStoresResponse>>(
    ApiBaseUrl + StoreUrl + "/IsVisitCollaborationStore",
    request,
  ).then((result) => {
    return result.data.data;
  });
};
